<!-- src/views/AdminDashboard.vue -->
<template>
  <DashboardLayout>
    <template #sidebar>
      <SidebarMenu
        :items="filteredNavItems"
        @switch="goToAskAI"
        @logout="logout"
      />
    </template>

    <template #header>
      <!-- LEFT: TaxScan AI Logo -->
      <AppLogo class="logo" />

      <!-- RIGHT: Welcome text, role badge, and sign-out button -->
      <div class="header-right flex items-center space-x-6">
        <span class="welcome-text">Welcome {{ username }}</span>
        <RoleBadge :role="role" />

        <!-- Colorful sign-out button -->
        <button
          @click="logout"
          class="logout-btn p-2 rounded focus:outline-none logout-icon-btn"
          aria-label="Sign out"
        >
          <img
            src="@/assets/Signout.png"
            alt="Sign out"
            class="logout-icon-img"
          />
        </button>
      </div>
    </template>

    <router-view />
  </DashboardLayout>
</template>

<script>
import DashboardLayout from '@/components/DashboardLayout.vue';
import SidebarMenu     from '@/components/SidebarMenu.vue';
import AppLogo         from '@/components/AppLogo.vue';
import RoleBadge       from '@/components/RoleBadge.vue';

export default {
  name: 'AdminDashboard',
  components: {
    DashboardLayout,
    SidebarMenu,
    AppLogo,
    RoleBadge
  },
  data() {
    return {
      username: localStorage.getItem('username') || '',
      role:     localStorage.getItem('role')     || '',
      navItems: [
        { name: 'Dashboard', icon: 'home',        to: { name: 'AdminDashboard' } },
        { name: 'Users',     icon: 'users',       to: { name: 'AdminUsers'     } },
        { name: 'Roles',     icon: 'user-shield', to: { name: 'AdminRoles'     } },
        { name: 'Payments',  icon: 'credit-card', to: { name: 'AdminPayments'  } },
        { name: 'Usage',     icon: 'list',        to: { name: 'AdminUsageLog'  } },
        { name: 'Ask AI',    icon: 'robot',       to: { name: 'AskAI'          } },
        // note: Marketplace is the manual <li> in SidebarMenu.vue
        { name: 'Signout',   icon: 'sign-out-alt', action: 'logout' }
      ]
    };
  },
  computed: {
    filteredNavItems() {
      // hide these for normal_user
      const hiddenForNormal = ['Dashboard','Users','Roles','Payments','Usage'];
      if (this.role === 'normal_user') {
        return this.navItems.filter(item => !hiddenForNormal.includes(item.name));
      }
      return this.navItems;
    }
  },
  methods: {
    goToAskAI() {
      this.$router.push({ name: 'AskAI' });
    },
    logout() {
      localStorage.clear();
      this.$router.replace({ name: 'Login' });
    }
  }
};
</script>

<style scoped>
/* Style the slotted header container */
::v-deep header.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.25rem 1rem;
}

/* Ensure AppLogo's img (class .logo) is always visible and sized */
::v-deep header.dashboard-header img.logo {
  display: block !important;
  width: auto !important;
  height: 100px !important;
  margin: 0 !important;
}

/* Header-right group styling */
.header-right {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}
.header-right .welcome-text {
  font-weight: var(--font-weight-medium);
}

/* RoleBadge spacing */
::v-deep .role-badge {
  margin: 0 var(--space-sm);
}

/* Logout button & icon */
.logout-icon-btn,
.logout-btn {
  display: flex;
  align-items: center;
  padding: var(--space-sm) var(--space-md);
  border: none;
  border-radius: var(--space-xs);
  background: var(--color-accent);
  cursor: pointer;
  transition: background 0.2s ease;
}
.logout-icon-btn:hover,
.logout-btn:hover {
  background: var(--color-accent-dark, #2563eb);
}
.logout-icon-img {
  width: 1.5rem;
  height: 1.5rem;
}

/* Mobile: hide welcome text + badge */
@media (max-width: 768px) {
  .header-right .welcome-text,
  ::v-deep .role-badge {
    display: none !important;
  }
  /* Center logo & logout vertically */
  ::v-deep header.dashboard-header img.logo {
    align-self: center !important;
  }
  ::v-deep header.dashboard-header .header-right {
    align-self: center !important;
    margin-left: auto;
    padding: 0 var(--space-md);
  }
}
</style>
